module.exports = __webpack_public_path__ + "static/media/wechat.a90c51aa.svg";